import { removeDuplicates } from './remove-duplicates';

export const getMemberEpisodes = (event, memberId) => {
    return event.stream
        .map((stream) => {
            const episodes = stream.episode.filter((episode) => {
                return episode.groups.some(({members}) => {
                    return members.some(({member}) => member.id === memberId);
                });
            });

            return episodes.map((episode) => ({...episode, stream}));
        })
        .flat()
        .sort((a, b) => a.timeStart - b.timeStart);
};

export const getMemberTopics = (event, memberId, locale) => {
    const memberEpisodes = getMemberEpisodes(event, memberId);

    if (!memberEpisodes?.length) return null;

    const memberGroups = memberEpisodes.map(({groups}) => {
        return groups.map(({members}) => {
            return members.filter(({member}) => member.id === memberId);
        });
    }).flat(3);

    if (!memberGroups?.length) return null;

    const resultGroups = removeDuplicates(memberGroups, 'id');

    const topics = resultGroups
        .map((group) => locale.getProperty(group, 'topic'))
        .filter((topic) => !!topic);

    return topics || null;
};

export const getSortedMembers = (members, locale, property, lang) => {
    return members.sort((a, b) => {
        return locale.getProperty(a, property).toLowerCase().localeCompare(
            locale.getProperty(b, property).toLowerCase(),
            lang,
        );
    });
};
